import { PREFILLED_EMAIL_PARAM } from './prefilled-email';

/**
 * Someone tried to sign up with an address that already has an account.
 *
 * 🔴 WE USED TO SHOW THEM AN ERROR AND LEAVE THEM THERE. 14 people hit this in the three days to
 * 2026-09-21, and they are the most qualified visitors we get: they already have accounts. A toast
 * saying the address is taken, on a page that cannot sign them in, asks them to work out for
 * themselves that the answer is a different page.
 */
export const EXISTING_ACCOUNT_PARAM = 'account_exists';

/**
 * Where to send them: sign-in, with the address they just typed and a marker so that page can say why
 * they were moved. UTMs and click ids ride along so the handoff does not break attribution.
 */
export function existingAccountSignInHref(emailAddress: string, allowlistedParams: string): string {
  const params = new URLSearchParams(allowlistedParams);
  params.set(EXISTING_ACCOUNT_PARAM, '1');

  const trimmed = emailAddress.trim();
  if (trimmed) {
    params.set(PREFILLED_EMAIL_PARAM, trimmed);
  }

  return `/sign-in?${params.toString()}`;
}

/** True when sign-in was reached from that handoff, which is the only time it explains itself. */
export function isExistingAccountArrival(searchParams: Pick<URLSearchParams, 'get'> | null): boolean {
  return searchParams?.get(EXISTING_ACCOUNT_PARAM) === '1';
}
